"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotAccountSummaryContainer = void 0;
var _reactRedux = require("react-redux");
var _SpotAccountSummaryComponent = _interopRequireDefault(require("./SpotAccountSummaryComponent"));
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var _spotAccountInfo = require("../../../redux/actions/spotAccountInfo");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var baseAsset = (0, _productsSelectors.baseNotionalProductSymbolSelector)(state);
  var accountSummary = state.spotAccountInfo.accountSummary;
  var baseAssetProduct = state.product.products.find(function (product) {
    return product.Product === baseAsset;
  });
  var baseAssetProductId = baseAssetProduct === null || baseAssetProduct === void 0 ? void 0 : baseAssetProduct.ProductId;
  var baseAssetDecimalPlaces = baseAssetProduct === null || baseAssetProduct === void 0 ? void 0 : baseAssetProduct.DecimalPlaces;
  return {
    baseAssetDecimalPlaces: baseAssetDecimalPlaces,
    accountSummary: accountSummary,
    baseAsset: baseAsset,
    baseAssetProductId: baseAssetProductId
  };
};
var SpotAccountSummaryContainer = exports.SpotAccountSummaryContainer = (0, _reactRedux.connect)(mapStateToProps, {
  getAccountSummary: _spotAccountInfo.getAccountSummary
})(_SpotAccountSummaryComponent["default"]);